import Vue from 'vue'
import VueRouter from 'vue-router'
import { BootstrapVue } from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import i18n from './i18n'
// import axios from 'axios'
import App from './App.vue'

// Vue.prototype.$http = axios
// Vue.prototype.$imgPath = 'https://s3.ap-northeast-2.amazonaws.com/factcheck.nolgong.com/webimg/'

Vue.prototype.$gameData = require('./assets/true_or_not-2021-09-09.json');
Vue.prototype.$loadGameData = function() {
    delete require.cache[require.resolve('./assets/true_or_not-2021-09-09.json')]
    Vue.prototype.$gameData = require('./assets/true_or_not-2021-09-09.json');
}

Vue.prototype.$store = window.localStorage
Vue.prototype.$get = function(key) {
    if(window.localStorage.getItem(key) == null) {
        return null
    }
    else {
        return JSON.parse(window.localStorage.getItem(key))
    }
}
Vue.prototype.$set = function(key, value) {
    window.localStorage.setItem(key, JSON.stringify(value))
}

Vue.prototype.$setCurrentPlayIndex = function (index) {
    this.$set('currentPlayIndex', index)
}
Vue.prototype.$getCurrentGame = function () {
    let currentPlayIndex = this.$get('currentPlayIndex')
    // console.log('currentPlayIndex: ' + currentPlayIndex)
    if (currentPlayIndex == null) {
        this.$set('currentPlayIndex', 0)
    }
    let games = this.$get('games')

    // return games[games.length - 1]
    return games[currentPlayIndex]
}
Vue.prototype.$setCurrentGame = function(currentGame) {
    let games = this.$get('games')
    for(let i = 0; i < games.length; i++) {
        let game = games[i]
        if(game.start_time == currentGame.start_time) {
            games[i] = currentGame
            this.$set('games', games)
            // console.log(games)
            break
        }
    }
}

Vue.prototype.$playBeep = function() {
    let sound = document.getElementById("beep");
    sound.play();
}
Vue.prototype.$playSuccess = function() {
    let sound = document.getElementById("success");
    sound.play();
}


import TitleView from './views/TitleView.vue'
import GameListView from './views/GameListView.vue'
import InputPlayersView from './views/InputPlayersView.vue'
import TutorialView from './views/TutorialView.vue'
import SectionListView from './views/SectionListView.vue'
import ArticleListView from './views/ArticleListView.vue'

import ArticleDetailView3 from './views/ArticleDetailView3.vue'
import ClueListView3 from './views/ClueListView3.vue'
import ClueDetailView3 from './views/ClueDetailView3.vue'

import SelectTrueOrNotView from './views/SelectTrueOrNotView.vue'
import JudgementView from './views/JudgementView.vue'
import ArticleResultView from './views/ArticleResultView.vue'
import FinalResultView from './views/FinalResultView.vue'

Vue.use(BootstrapVue)
Vue.use(VueRouter)

Vue.config.productionTip = false

const router = new VueRouter({
    routes: [
        {path: "/", component: TitleView},
        {path: "/gameList", component: GameListView},
        {path: "/inputPlayers", component: InputPlayersView},
        {path: "/tutorial", component: TutorialView},
        {path: "/sectionList", component: SectionListView},
        {path: "/articleList", component: ArticleListView},

        {path: "/articleDetail3", component: ArticleDetailView3},
        {path: "/clueList3", component: ClueListView3},
        {path: "/clueDetail3", component: ClueDetailView3},

        {path: "/selectTrueOrNot", component: SelectTrueOrNotView},
        {path: "/judgement", component: JudgementView},
        {path: "/articleResult", component: ArticleResultView},
        {path: "/finalResult", component: FinalResultView},
    ]
})


new Vue({
    router,
    i18n,
    render: h => h(App)
}).$mount('#app')
